var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	1568: {
		fallback: function() { return __webpack_require__.e(8).then(function() { return function() { return __webpack_require__(9008); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^12 || ^13 || ^14 || ^15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/head",
	},
	1594: {
		fallback: function() { return Promise.all([__webpack_require__.e(918), __webpack_require__.e(705), __webpack_require__.e(163), __webpack_require__.e(521)]).then(function() { return function() { return __webpack_require__(1163); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/router",
	},
	8371: {
		fallback: function() { return Promise.all([__webpack_require__.e(918), __webpack_require__.e(63)]).then(function() { return function() { return __webpack_require__(1664); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^12 || ^13 || ^14 || ^15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/link",
	},
	9094: {
		fallback: function() { return Promise.all([__webpack_require__.e(705), __webpack_require__.e(521), __webpack_require__.e(293)]).then(function() { return function() { return __webpack_require__(4298); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^12 || ^13 || ^14 || ^15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/script",
	},
	4977: {
		fallback: function() { return Promise.all([__webpack_require__.e(675), __webpack_require__.e(521)]).then(function() { return function() { return __webpack_require__(5675); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^12 || ^13 || ^14 || ^15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/image",
	},
	8477: {
		fallback: function() { return __webpack_require__.e(152).then(function() { return function() { return __webpack_require__(8860); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^12 || ^13 || ^14 || ^15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/dynamic",
	},
	8081: {
		fallback: function() { return __webpack_require__.e(774).then(function() { return function() { return __webpack_require__(5893); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react/jsx-runtime",
	},
	2657: {
		fallback: function() { return function() { return __webpack_require__(7294); }; },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "18.3.1",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react",
	},
	5739: {
		fallback: function() { return __webpack_require__.e(621).then(function() { return function() { return __webpack_require__(2621); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^5.1.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "styled-jsx",
	},
	8882: {
		fallback: function() { return __webpack_require__.e(543).then(function() { return function() { return __webpack_require__(2543); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^5.1.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "styled-jsx/style",
	},
	6179: {
		fallback: function() { return function() { return __webpack_require__(8711); }; },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "11.11.0",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "@emotion/cache",
	},
	5910: {
		fallback: function() { return function() { return __webpack_require__(7446); }; },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "11.10.8",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "@emotion/react",
	},
	8813: {
		fallback: function() { return __webpack_require__.e(774).then(function() { return function() { return __webpack_require__(745); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-dom/client",
	},
	5521: {
		fallback: function() { return function() { return __webpack_require__(3935); }; },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "18.3.1",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react-dom",
	},
	1277: {
		fallback: function() { return __webpack_require__.e(152).then(function() { return function() { return __webpack_require__(8860); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "14.2.33",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/dynamic",
	},
	2622: {
		fallback: function() { return __webpack_require__.e(298).then(function() { return function() { return __webpack_require__(4298); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "14.2.33",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/script",
	},
	4388: {
		fallback: function() { return __webpack_require__.e(664).then(function() { return function() { return __webpack_require__(1664); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "14.2.33",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/link",
	},
	5930: {
		fallback: function() { return function() { return __webpack_require__(1599); }; },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "11.10.8",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "@emotion/styled",
	},
	6921: {
		fallback: function() { return __webpack_require__.e(8).then(function() { return function() { return __webpack_require__(9008); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "14.2.33",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/head",
	}
};
var moduleToHandlerMapping = {};
__webpack_require__.consumesLoadingData.initialConsumes = [1568,1594,8371,9094,4977,8477,8081,2657,5739,8882,6179,5910,8081,2657,8813,5521,6179,5910,1594,1277];
__webpack_require__.federation.installInitialConsumes = function() { return __webpack_require__.federation.bundlerRuntime.installInitialConsumes({
	initialConsumes: __webpack_require__.consumesLoadingData.initialConsumes,
	installedModules:installedModules,
	moduleToHandlerMapping,
	webpackRequire: __webpack_require__
}); }
__webpack_require__.consumesLoadingData.chunkMapping = {
	"137": [
		1568,
		1594,
		8371,
		9094,
		4977,
		8477,
		8081,
		2657,
		5739,
		8882,
		6179,
		5910
	],
	"179": [
		8081,
		2657,
		8813,
		5521,
		6179,
		5910
	],
	"277": [
		1277
	],
	"521": [
		5521
	],
	"563": [
		2622,
		4388,
		5930,
		6921
	],
	"888": [
		1594
	]
};
__webpack_require__.f.consumes = function(chunkId, promises) {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}